import { z } from 'zod';

/**
 * Import/merge tracking shared by CRM contacts and companies (HubSpot migration).
 * See apps/crm/prd/hubspot-migration/hubspot-csv-import.md.
 *
 * - `imported` — the row was newly created by an import.
 * - `merged`   — the import matched an existing Xthory row and filled only its
 *                empty fields; conflicting HubSpot values are kept in
 *                `importConflicts` (Xthory value always wins).
 */
export const importStatusValues = ['imported', 'merged'] as const;
export const importStatusSchema = z.enum(importStatusValues);
export type ImportStatus = z.infer<typeof importStatusSchema>;

/** Per-field conflict record: the kept Xthory value vs the incoming HubSpot value. */
export const importConflictsSchema = z
  .record(z.string(), z.object({ xt: z.unknown(), hubspot: z.unknown() }))
  .nullable();
export type ImportConflicts = z.infer<typeof importConflictsSchema>;
